import { useTranslation } from "react-i18next"

import MyModal from "@/components/MyModal/MyModal"
import { MODALS } from "@/constants/modals"

import ProjectAdd from "./ProjectAdd"
import ProjectEdit from "./ProjectEdit"

export default function ProjectsModals() {
  const { t } = useTranslation()
  return (
    <>
      <MyModal
        size="lg"
        modalName={MODALS.projects.add}
        title={t("projectsModalTitles.addProject")}
      >
        <ProjectAdd />
      </MyModal>
      <MyModal
        size="lg"
        modalName={MODALS.projects.edit}
        title={t("projectsModalTitles.editProject")}
      >
        <ProjectEdit />
      </MyModal>
    </>
  )
}
